export enum QueryKeys {
  ACCOUNTS = 'accounts',
  ASSISTANT = 'assistant',
  BALANCE_HISTORY = 'balanceHistory',
  CASHFLOWS = 'cashflows',
  CATEGORIES = 'categories',
  TRANSACTIONS = 'transactions',
}
